var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4243_6421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9921 26.053V65.0884C71.9921 67.0912 71.1402 68.8941 69.7795 70.1559C68.5457 71.3006 66.8939 71.9999 65.0796 71.9999H6.91198C5.09759 71.9999 3.4458 71.3006 2.21313 70.1575C0.853026 68.8941 0.000488281 67.0912 0.000488281 65.0884V26.053H71.9921Z",
    fill: "#FEC970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9916 26.0528L44.3199 3.01179C39.4969 -1.00426 32.4948 -1.00426 27.6718 3.01179L0 26.0528H0.000549316L8.15624 32.8435L27.6718 49.0928C32.4953 53.1099 39.4974 53.1099 44.3193 49.0928L63.8365 32.8435L71.9922 26.0528",
    fill: "#FBA028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8365 11.6734V32.8435L44.3193 49.0928C39.4975 53.11 32.4953 53.11 27.6718 49.0928L8.15625 32.8435V11.6734C8.15625 7.2597 11.735 3.68091 16.1499 3.68091H55.844C60.2588 3.68091 63.8365 7.2597 63.8365 11.6734Z",
    fill: "#BFDADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8365 11.6734V27.9947L44.3193 44.2446C39.4975 48.2612 32.4953 48.2612 27.6718 44.2446L8.15625 27.9947V11.6734C8.15625 7.2597 11.735 3.68091 16.1499 3.68091H55.844C60.2588 3.68091 63.8365 7.2597 63.8365 11.6734Z",
    fill: "#E4F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2816 67.5143C65.0333 67.5143 64.7834 67.4308 64.5774 67.2594L47.0065 52.63C46.539 52.2406 46.4758 51.5457 46.8647 51.0782C47.2542 50.6107 47.9491 50.547 48.4165 50.9365L65.987 65.5653C66.455 65.9548 66.5187 66.6491 66.1292 67.1171C65.9111 67.3792 65.5975 67.5143 65.2816 67.5143Z",
    fill: "#FBA028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9509 52.6591L10.5116 64.9929C8.52202 66.6924 9.41136 69.9405 11.9893 70.3888C16.1361 71.1095 20.9816 71.9181 22.2846 71.9999H6.91198C5.09759 71.9999 3.4458 71.3006 2.21313 70.1575C0.853026 68.8941 0.000488281 67.0912 0.000488281 65.089V26.053H5.21789V52.6624C5.26788 58.0413 11.574 60.9279 15.7082 57.487L23.576 50.9359C24.0517 50.5409 24.7642 50.6129 25.1493 51.1051C25.5211 51.5791 25.414 52.274 24.9509 52.6591Z",
    fill: "#FBA028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1576 31.6269H19.8353C19.2267 31.6269 18.7334 31.1337 18.7334 30.525C18.7334 29.9169 19.2267 29.4231 19.8353 29.4231H52.1576C52.7662 29.4231 53.2595 29.9169 53.2595 30.525C53.2595 31.1337 52.7662 31.6269 52.1576 31.6269Z",
    fill: "#4B5051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1576 38.0271H19.8353C19.2267 38.0271 18.7334 37.5338 18.7334 36.9252C18.7334 36.3165 19.2267 35.8232 19.8353 35.8232H52.1576C52.7662 35.8232 53.2595 36.3165 53.2595 36.9252C53.2595 37.5338 52.7662 38.0271 52.1576 38.0271Z",
    fill: "#4B5051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1576 18.8279H19.8353C19.2267 18.8279 18.7334 18.334 18.7334 17.726C18.7334 17.1173 19.2267 16.624 19.8353 16.624H52.1576C52.7662 16.624 53.2595 17.1173 53.2595 17.726C53.2595 18.334 52.7662 18.8279 52.1576 18.8279Z",
    fill: "#4B5051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1576 25.2273H19.8353C19.2267 25.2273 18.7334 24.734 18.7334 24.1254C18.7334 23.5167 19.2267 23.0234 19.8353 23.0234H52.1576C52.7662 23.0234 53.2595 23.5167 53.2595 24.1254C53.2595 24.734 52.7662 25.2273 52.1576 25.2273Z",
    fill: "#4B5051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4243_6421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5fa8dc6bfc9ca9c2684bf64e7bcda5e5.svg";
export { ForwardRef as ReactComponent };